import { TooltipHover } from "components/designV2/tooltip/tooltip";
import { V2_ICON_MIN_SIZE } from "components/designV2/constants";
import { CustomIcon } from "components/icon/customIcon.component";
import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";
import styled from "styled-components";

export interface InfoTextProps {
  text: string;
  tooltipText: string;
  tooltipIconName?: string;
  textColor?: ColorV2;
  iconColor?: ColorV2;
  textStyle?: keyof typeof TypographyV2;
  iconSize?: number;
}

/** Text with info icon and tooltip. */
export const InfoText = ({
  text,
  tooltipText,
  tooltipIconName = "v2/info",
  textColor = ColorV2.Blue2,
  iconColor = ColorV2.Blue4,
  textStyle = "s1",
  iconSize,
}: InfoTextProps): JSX.Element => {
  const resolvedIconSize = Math.max(
    iconSize ?? getDefaultIconSize(textStyle),
    V2_ICON_MIN_SIZE
  );

  return (
    <Wrapper>
      <Text $color={textColor} $style={textStyle}>
        {text}
      </Text>
      <TooltipHover text={tooltipText} iconName={tooltipIconName} arrow="down">
        <IconWrap>
          <CustomIcon
            name={tooltipIconName}
            size={`${resolvedIconSize}px`}
            color={iconColor}
          />
        </IconWrap>
      </TooltipHover>
    </Wrapper>
  );
};

const getDefaultIconSize = (style: keyof typeof TypographyV2): number => {
  switch (style) {
    case "h3":
    case "h4":
      return 32;
    case "h5":
    case "b1":
      return 28;
    default:
      return 24;
  }
};

const Wrapper = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
`;

const Text = styled.span<{ $color: ColorV2; $style: keyof typeof TypographyV2 }>`
  ${({ $style }) => TypographyV2[$style]};
  color: ${(props) => props.$color};
`;

const IconWrap = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;
